export default function Button({
    children,
    variant = 'primary',
    className = '',
    loading = false,
    disabled = false,
    ...props
}) {
    const baseClass = 'btn';
    const variantClasses = {
        primary: 'btn-primary',
        outline: 'btn-outline',
        success: 'btn-success',
    };

    return (
        <button
            className={`${baseClass} ${variantClasses[variant]} ${className} ${(loading || disabled) ? 'opacity-50 cursor-not-allowed' : ''
                }`}
            disabled={loading || disabled}
            {...props}
        >
            {loading ? (
                <span className="flex items-center gap-2">
                    <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Carregando...
                </span>
            ) : (
                children
            )}
        </button>
    );
}
